import URI from 'urijs';
import Promise from 'bluebird';
import RestfulServiceBase from '@bingads-webui-clientcenter/restful-service';
import type { RequestOptions } from '@bingads-webui-clientcenter/restful-service';
import type {
  CCNetworkRequestor,
  CCRequestorOptions,
  CCResponse,
} from '../types';

// Some cc calls take LCIDCookie as local input, which will return non-English data
const localeParam = 'mkt';
const localeUs = 'en-US';


const isCCError = (response: CCResponse) => response.ResultType === 1 || response.ResultType === 3;

export function getRequestor({
  serviceRoot,
  locale,
}: CCRequestorOptions): CCNetworkRequestor {
  return function networkRequestor(uri, requestVerb, options, body) {
    const restfulService = new RestfulServiceBase({});
    const cleanedRootUrl = URI(serviceRoot).path('').toString();
    const currentLocale = locale || localeUs;
    const uriWithLocale = URI(uri).addQuery(localeParam, currentLocale).toString();

    const url = `${cleanedRootUrl}${uriWithLocale}`;

    return restfulService.http.ajax(url, {
      method: requestVerb,
      data: JSON.stringify(body),
      ...options,
    } as RequestOptions, undefined).then((response) => {
      if (isCCError(response)) {
        return Promise.reject(response);
      }
      return response;
    }) as Promise<CCResponse>;
  };
}
